var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticClass:"w-100",attrs:{"data":_vm.tableData}},_vm._l((_vm.tableColumn),function(dataItem,index){return _c('el-table-column',{key:index,attrs:{"prop":dataItem.prop,"label":dataItem.label,"width":dataItem.w}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }